import React from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { Loader } from '../../components/Loader';
import { DASHBOARD } from '../../shared/constants';
import { StateType } from '../../reducers';
import { hasConsultantOrResearcherPermission } from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import { dataTeamIsFetchedSelector, dataTeamIsInAnActiveTeam } from '../../reducers/TeamReducer/DataTeamReducer/DataTeamSelector';

export interface WithTeamGuardStateProps {
  isConsultantOrResearcher: boolean;
  isFetchedTeams: boolean;
  isInAnActiveTeam: boolean;
}

export function withTeamGuard<TProps = any>(Component: React.ComponentType<TProps>) {
  const componentDisplayName = (Component?.displayName ?? Component?.name) || 'Component';

  function ComponentWithTeamGuard({
    isConsultantOrResearcher,
    isFetchedTeams,
    isInAnActiveTeam,
    ...forwardingProps
  }: WithTeamGuardStateProps & TProps) {
    if (isConsultantOrResearcher && !isFetchedTeams) {
      return <Loader active={true} inline="centered" size="massive" />;
    }

    if (!isConsultantOrResearcher || (isFetchedTeams && isInAnActiveTeam)) {
      return <Component {...(forwardingProps as TProps & JSX.IntrinsicAttributes)} />;
    }

    return <Redirect to={DASHBOARD} />;
  }

  ComponentWithTeamGuard.displayName = `withTeamGuard(${componentDisplayName})`;

  const mapState: MapStateToProps<WithTeamGuardStateProps, TProps, StateType> = state => ({
    isConsultantOrResearcher: hasConsultantOrResearcherPermission(state),
    isFetchedTeams: dataTeamIsFetchedSelector(state) as boolean,
    isInAnActiveTeam: dataTeamIsInAnActiveTeam(state),
  });

  // @ts-expect-error connect TOwnProps=any collapses own-props under @types/react@19
  return connect<WithTeamGuardStateProps, any, TProps, StateType>(mapState, null)(ComponentWithTeamGuard);
}
